export interface ZoomableImageViewport {
  width: number;
  height: number;
  minScale: number;
  maxScale: number;
  imageWidth?: number;
  imageHeight?: number;
}

export interface ZoomableImageTransform {
  scale: number;
  translateX: number;
  translateY: number;
}

const clamp = (value: number, min: number, max: number) => {
  'worklet';
  if (min === 0 && max === 0) {
    return 0;
  }

  return Math.max(min, Math.min(max, value));
};

export const getMaxTranslation = (
  currentScale: number,
  viewport: ZoomableImageViewport,
) => {
  'worklet';
  const imageWidth =
    viewport.imageWidth && viewport.imageWidth > 0
      ? viewport.imageWidth
      : viewport.width;
  const imageHeight =
    viewport.imageHeight && viewport.imageHeight > 0
      ? viewport.imageHeight
      : viewport.height;
  const containScale = Math.min(
    viewport.width / imageWidth,
    viewport.height / imageHeight,
  );
  const scaleRatio = currentScale / viewport.minScale;
  const renderedWidth = imageWidth * containScale * scaleRatio;
  const renderedHeight = imageHeight * containScale * scaleRatio;

  return {
    x: Math.max(0, (renderedWidth - viewport.width) / 2),
    y: Math.max(0, (renderedHeight - viewport.height) / 2),
  };
};

export const constrainTransform = (
  transform: ZoomableImageTransform,
  viewport: ZoomableImageViewport,
): ZoomableImageTransform => {
  'worklet';
  const scale = clamp(transform.scale, viewport.minScale, viewport.maxScale);
  const maxTranslation = getMaxTranslation(scale, viewport);

  return {
    scale,
    translateX: clamp(
      transform.translateX,
      -maxTranslation.x,
      maxTranslation.x,
    ),
    translateY: clamp(
      transform.translateY,
      -maxTranslation.y,
      maxTranslation.y,
    ),
  };
};
